import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export default class extends Controller {
  static targets = ['element']

  static values = {
    autoSubmit: { type: Boolean, default: false },
    preventValidation: { type: Boolean, default: false },
    buttonSubmit: { type: Boolean, default: false }
  }

  connect() {
    this.swiper = new Swiper(this.element, {
      slidesPerView: 2,
      spaceBetween: 20,
      pagination: {
        el: this.element.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: this.element.querySelector('.swiper-button-next'),
        prevEl: this.element.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
        },
        1024: {
          slidesPerView: 5,
        },
      },
    });
  }

  disconnect() {
    this.swiper?.destroy(true, true);
    this.swiper = undefined;
  }
}
